import React, { useState } from 'react';
import notify from './utils/notify';
import './BetModals.css';

const PlaceBetModal = ({ selectedTournament, odds, onPlaceBet, onCancel }) => {
  const [betOwner, setBetOwner] = useState('');
  const [selectedPlayerId, setSelectedPlayerId] = useState('');
  const [stake, setStake] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!betOwner || !selectedPlayerId || !stake) {
      notify.warn('Please fill in all fields.');
      return;
    }

    const playerOdds = odds.find(o => o.player_id === parseInt(selectedPlayerId));
    if (!playerOdds) {
      notify.warn('Selected player odds not found.');
      return;
    }

    // NO PRICE IS SENT. The server reads it off the stored quote — this used
    // to carry `odds` and the server booked whatever arrived, so the punter
    // chose what their own bet paid.
    const betData = {
      tournament_id: selectedTournament,
      player_id: selectedPlayerId,
      name: betOwner,
      stake: parseFloat(stake),
    };

    onPlaceBet(betData);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ borderRadius: '16px', padding: '24px', maxWidth: '400px' }}>
        <div className="card-title-sm" style={{ fontSize: '1.1rem', marginBottom: '24px', textAlign: 'center' }}>Place New Prediction</div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body" style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <div className="form-group">
              <label className="input-label-sm" htmlFor="betOwner">Prediction By</label>
              <input
                className="premium-input"
                type="text"
                id="betOwner"
                placeholder="Who is making the prediction?"
                value={betOwner}
                onChange={(e) => setBetOwner(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label className="input-label-sm" htmlFor="player">Select Player</label>
              <select
                className="premium-input"
                id="player"
                value={selectedPlayerId}
                onChange={(e) => setSelectedPlayerId(e.target.value)}
              >
                <option value="">Choose a player...</option>
                {odds.map(playerOdds => (
                  <option key={playerOdds.player_id} value={playerOdds.player_id}>
                    {playerOdds.player_name} ({playerOdds.odds})
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label className="input-label-sm" htmlFor="stake">Stake Amount (£)</label>
              <input
                className="premium-input"
                type="number"
                id="stake"
                placeholder="0.00"
                value={stake}
                onChange={(e) => setStake(e.target.value)}
              />
            </div>
          </div>
          <div className="modal-actions" style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '24px' }}>
            <button type="submit" className="btn-primary-bet">Confirm Placement</button>
            <button type="button" className="btn-secondary-bet" onClick={onCancel}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PlaceBetModal;